import { vm } from '@/main';

export function useVuetify() {
  return vm.$vuetify;
}
